"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamePreset = void 0;
var typeorm_1 = require("typeorm");
var GamePresetAction_entity_1 = require("./GamePresetAction.entity");
var GamePreset = /** @class */ (function () {
    function GamePreset() {
    }
    __decorate([
        (0, typeorm_1.PrimaryGeneratedColumn)(),
        __metadata("design:type", Number)
    ], GamePreset.prototype, "id", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], GamePreset.prototype, "name", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", String)
    ], GamePreset.prototype, "label", void 0);
    __decorate([
        (0, typeorm_1.Column)(),
        __metadata("design:type", Number)
    ], GamePreset.prototype, "noOfRounds", void 0);
    __decorate([
        (0, typeorm_1.OneToMany)(function () { return GamePresetAction_entity_1.GamePresetAction; }, function (action) { return action.preset; }),
        __metadata("design:type", Array)
    ], GamePreset.prototype, "gamePresetActions", void 0);
    GamePreset = __decorate([
        (0, typeorm_1.Entity)({ name: 'game_preset' })
    ], GamePreset);
    return GamePreset;
}());
exports.GamePreset = GamePreset;
//# sourceMappingURL=GamePreset.entity.js.map